"use strict";

import User from "./User.jsx";

export const auth = true;
export const title = "i18n:user.pageTitle";
export const Component = User;
